import {Action} from '@ngrx/store';
import {
	ISalaryExpensesStatisticsFilter,
	IStatistics,
	IStatisticsRevenueFilter
} from '@app/core/services/api/statistic.service';
import {Moment} from 'moment';
import {ISalaryPercentageModel} from '@app/core/models/salary-percentage-live.model';
import {ETURNOVERTYPE} from '@app/core/enums';
import {ISalaryExpenseStatisticsModel} from '@app/core/models/salary-expense-statistics.model';
import {IRevenueStatisticsModel} from '@app/core/models/statistics-revenue.model';
import {IQODateRange} from '@quickorder/angular-web-lib';

export enum EStatisticsActions {
	GetStatistics = '[Statistics] Get Statistics',
	GetStatisticsSuccess = '[Statistics] Get Statistics Success',
	PatchTurnover = '[Statistics] Patch Turnover',
	PatchTurnoverSuccess = '[Statistics] Patch Turnover Success',
	GetSalaryPercentage = '[Statistics] Get Salary Percentage',
	GetSalaryPercentageSuccess = '[Statistics] Get Salary Percentage Success',

	// Statistics module

	GetSalaryExpenseStatistics = '[Statistics] Get Salary Expense Statistics',
	GetSalaryExpenseStatisticsSuccess = '[Statistics] Get Salary Expense Statistics Success',
	GetRevenueStatistics = '[Statistics] Get Revenue Statistics',
	GetRevenueStatisticsSuccess = '[Statistics] Get Revenue Statistics Success',
	SetStatisticsDateRange = '[Statistics] Set Statistics Date Range',
}

export class GetStatistics implements Action {
	public readonly type = EStatisticsActions.GetStatistics;

	constructor(public start_date: Moment, public end_date: Moment) {
	}
}

export class GetStatisticsSuccess implements Action {
	public readonly type = EStatisticsActions.GetStatisticsSuccess;

	constructor(public statistics: IStatistics) {
	}
}

export class PatchTurnover implements Action {
	public readonly type = EStatisticsActions.PatchTurnover;

	constructor(public date: Moment, public data: { turnover: number, type: ETURNOVERTYPE }) {
	}
}

export class PatchTurnoverSuccess implements Action {
	public readonly type = EStatisticsActions.PatchTurnoverSuccess;

	constructor(public date: Moment, public data: { turnover: number, type: ETURNOVERTYPE }) {
	}
}

export class GetSalaryPercentage implements Action {
	public readonly type = EStatisticsActions.GetSalaryPercentage;

	constructor() {
	}
}

export class GetSalaryPercentageSuccess implements Action {
	public readonly type = EStatisticsActions.GetSalaryPercentageSuccess;

	constructor(public data: ISalaryPercentageModel[]) {
	}
}

// Statistics module

export class GetSalaryExpenseStatistics implements Action {
	public readonly type = EStatisticsActions.GetSalaryExpenseStatistics;

	constructor(public from: Moment, public to: Moment, public filters: ISalaryExpensesStatisticsFilter, public includeRevenue: boolean = false) {
	}
}

export class GetSalaryExpenseStatisticsSuccess implements Action {
	public readonly type = EStatisticsActions.GetSalaryExpenseStatisticsSuccess;

	constructor(public data: ISalaryExpenseStatisticsModel[]) {
	}
}

export class GetRevenueStatistics implements Action {
	public readonly type = EStatisticsActions.GetRevenueStatistics;

	constructor(public from: Moment, public to: Moment, public filters: IStatisticsRevenueFilter) {
	}
}

export class GetRevenueStatisticsSuccess implements Action {
	public readonly type = EStatisticsActions.GetRevenueStatisticsSuccess;

	constructor(public data: IRevenueStatisticsModel[]) {
	}
}

export class SetStatisticsDateRange implements Action {
	public readonly type = EStatisticsActions.SetStatisticsDateRange;

	constructor(public dateRange: IQODateRange<Moment>) {
	}
}

export type StatisticsActions =
	GetStatistics |
	GetStatisticsSuccess |
	PatchTurnover |
	PatchTurnoverSuccess |
	GetSalaryPercentage |
	GetSalaryPercentageSuccess |
	GetSalaryExpenseStatistics |
	GetSalaryExpenseStatisticsSuccess |
	GetRevenueStatistics |
	GetRevenueStatisticsSuccess |
	SetStatisticsDateRange
	;
